"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArcaneBlastAbilityHandler = exports.ArcaneBlastActorAbilityFactory = exports.ArcaneBlastAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const MaxAttributeDecrease_1 = require("../../core/effects/core/MaxAttributeDecrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class ArcaneBlastAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.ArcaneBlast;
        this.__typeName = "ArcaneBlast";
    }
}
exports.ArcaneBlastAbilityArgs = ArcaneBlastAbilityArgs;
let ArcaneBlastActorAbilityFactory = class ArcaneBlastActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("ArcaneBlast", "AllEnemies", 1);
    }
};
ArcaneBlastActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("ArcaneBlast")
], ArcaneBlastActorAbilityFactory);
exports.ArcaneBlastActorAbilityFactory = ArcaneBlastActorAbilityFactory;
let ArcaneBlastAbilityHandler = class ArcaneBlastAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        // TODO: Update this to an AOE effect that is more of an explosion in the center of the enemies expanding outwards
        const projectiles = [];
        for (const enemy of enemies) {
            projectiles.push({
                targetId: enemy,
                path: "sin",
                type: "ArcaneBolt",
                damages: [
                    AbilityDamage_1.AbilityDamage.Focus("Chaos", 40)
                ]
            });
        }
        container.applyProjectileAttacksWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackerId: ability.invokerId,
            attackType: "magic",
            projectiles,
            onHit(sequence, attack, damage, projectile) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId: projectile.targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(AttributeType_1.AttributeType.ChaosDamageImmunity, 25),
                });
            }
        });
    }
};
ArcaneBlastAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.ArcaneBlast)
], ArcaneBlastAbilityHandler);
exports.ArcaneBlastAbilityHandler = ArcaneBlastAbilityHandler;
